import type { Language } from "./registration";

export const FOOD_DRIVE_EVENT = {
  id: "RCCFD2026-OCT24",
  qrPrefix: "RCCFD2026-OCT24",
  registrationPrefix: "FD26OCT",
  name: "Redeemers 10th Anniversary Food Drive",
  date: "2026-10-24",
  time: "10:00 AM ET",
  timeZone: "America/New_York",
  addressLine: "10001 Aerospace Road",
  cityStateZip: "Lanham, MD 20706",
  location: "10001 Aerospace Road, Lanham, MD 20706",
  flyerPath: "/food-drive-flyer-october-2026.jpg",
  dateCopy: {
    EN: { short: "Saturday, October 24", full: "Saturday, October 24, 2026", form: "October 24 · 10:00 AM ET", email: "Saturday, October 24, 2026 at 10:00 AM Eastern Time" },
    ES: { short: "Sábado 24 de octubre", full: "Sábado 24 de octubre de 2026", form: "24 de octubre · 10:00 AM ET", email: "Sábado 24 de octubre de 2026 a las 10:00 AM, hora del Este" },
    FR: { short: "Samedi 24 octobre", full: "Samedi 24 octobre 2026", form: "24 octobre · 10 h HE", email: "Samedi 24 octobre 2026 à 10 h, heure de l’Est" },
  } satisfies Record<Language, { short: string; full: string; form: string; email: string }>,
} as const;
